import React, { useEffect, useRef, useState } from "react";
import "./PopUpCalificar.css";
// import Confetti from "react-confetti";
//import iconopopup from "../../assets/img/NotificacionesModales/Modal Carnaval 2025 (Pc).png";
//import iconopopupTablet from "../../assets/img/NotificacionesModales/Modal Carnaval 2025 (Tablet).png";
//import iconopopupCel from "../../assets/img/NotificacionesModales/Modal Carnaval 2025 (Celular).png";
//import iconopopup from "../../assets/img/NotificacionesModales/Modales_(Demoras_en _mañana se acredita_)_Tamaño_Pc.png";
//import iconopopupTablet from "../../assets/img/NotificacionesModales/Modales_(Demoras_en _mañana se acredita_)_Tamaño_Celular.png";
//import iconopopupCel from "../../assets/img/NotificacionesModales/Modales_(Demoras_en _mañana se acredita_)_Tamaño_Celular.png";
//import iconopopup from "../../assets/img/NotificacionesModales/Pago diferido - Día de la memoria (tamaño Pc).png";
//import iconopopupTablet from "../../assets/img/NotificacionesModales/Pago diferido - Día de la memoria (tamaño tablet).png";
//import iconopopupCel from "../../assets/img/NotificacionesModales/Pago diferido - Día de la memoria (tamaño celular).png";
//import iconopopup from "../../assets/img/NotificacionesModales/Jueves y Viernes Santo (PC).png"; ultimo trabajito de la sofi :(
//import iconopopupTablet from "../../assets/img/NotificacionesModales/Jueves y Viernes Santo (Tablet).png"; ultimo trabajito de la sofi :(
//import iconopopupCel from "../../assets/img/NotificacionesModales/Jueves y Viernes Santo (Celular).png"; ultimo trabajito de la sofi :(
//import iconopopup from "../../assets/img/NotificacionesModales/Modales-web-(Junio)-Horizontal.png";
//import iconopopupTablet from "../../assets/img/NotificacionesModales/Modales-web-(Junio)-Cuadrado.png";
//import iconopopupCel from "../../assets/img/NotificacionesModales/Modales-web-(Junio)-Vertical.png";
//import iconopopup from "../../assets/img/NotificacionesModales/modal-tasas-PC.png";
//import iconopopupTablet from "../../assets/img/NotificacionesModales/modal-tasas-tablet.png";
//import iconopopupCel from "../../assets/img/NotificacionesModales/modal-tasas-celular.png";
//import iconopopup from "../../assets/img/NotificacionesModales/modal promo PC.png";
//import iconopopupTablet from "../../assets/img/NotificacionesModales/modal promo tablet.png";
//import iconopopupCel from "../../assets/img/NotificacionesModales/modal promo celular.png";
//import iconopopup from "../../assets/img/NotificacionesModales/modal_PC.png";
//import iconopopupTablet from "../../assets/img/NotificacionesModales/modal_TABLET.png";
//import iconopopupCel from "../../assets/img/NotificacionesModales/modal_CELULAR.png";
//import iconopopup from "../../assets/img/NotificacionesModales/modal_PC_pagodiferido1010.png";
//import iconopopupTablet from "../../assets/img/NotificacionesModales/modal_tablet_pagodiferido1010.png";
//import iconopopupCel from "../../assets/img/NotificacionesModales/modal_celular_pagodiferido1010.png";
//import iconopopup from "../../assets/img/NotificacionesModales/modal_pc_DIAMADRE.png";
//import iconopopupTablet from "../../assets/img/NotificacionesModales/modal_tablet_DIAMADRE.png";
//import iconopopupCel from "../../assets/img/NotificacionesModales/modal_celular_DIAMADRE.png";
//import iconopopup from "../../assets/img/NotificacionesModales/modal_fecha_diferida_PC0611.png";
//import iconopopupTablet from "../../assets/img/NotificacionesModales/modal_fecha_diferida_tablet0611.png";
//import iconopopupCel from "../../assets/img/NotificacionesModales/modal_fecha_diferida_celular0611.png";
//import iconopopup from "../../assets/img/NotificacionesModales/modal_PC131125.png";
//import iconopopupTablet from "../../assets/img/NotificacionesModales/modal_tablet131125.png";
//import iconopopupCel from "../../assets/img/NotificacionesModales/modal_celular131125.png";
//import iconopopup from "../../assets/img/NotificacionesModales/modalpc2111.png";
//import iconopopupTablet from "../../assets/img/NotificacionesModales/modaltablet2111.png";
//import iconopopupCel from "../../assets/img/NotificacionesModales/modalcelular2111.png";
//import iconopopup from "../../assets/img/NotificacionesModales/modal_acreditaciones_pc2711.png";
//import iconopopupTablet from "../../assets/img/NotificacionesModales/modal_acreditaciones_tablet2711.png";
//import iconopopupCel from "../../assets/img/NotificacionesModales/modal_acreditaciones_celular2711.png";
//import iconopopup from "../../assets/img/NotificacionesModales/modal_fecha_diferida_pc812.png";
//import iconopopupTablet from "../../assets/img/NotificacionesModales/modal_fecha_diferida_tablet812.png";
//import iconopopupCel from "../../assets/img/NotificacionesModales/modal_fecha_diferida_celular812.png";
//import iconopopup from "../../assets/img/NotificacionesModales/modal_fecha_diferida_PC_2412.png";
//import iconopopupTablet from "../../assets/img/NotificacionesModales/modal_fecha_diferida_tablet_2412.png";
//import iconopopupCel from "../../assets/img/NotificacionesModales/modal_fecha_diferida_celular_2412.png";
import iconopopup from "../../assets/img/NotificacionesModales/modal fceha diferida PC3112.png";
import iconopopupTablet from "../../assets/img/NotificacionesModales/modal fecha diferida tablet3112.png";
import iconopopupCel from "../../assets/img/NotificacionesModales/modal fecha diferida celular3112.png";
import { Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Fireworks } from "fireworks-js";

const PopUpNotificaciones = ({ onClose }) => {
    const containerRef = useRef(null);
    const modalRef = useRef(null);

    // Estados para saber si cada imagen se cargó
    const [imgLoadedDesktop, setImgLoadedDesktop] = useState(false);
    const [imgLoadedTablet, setImgLoadedTablet] = useState(false);
    const [imgLoadedMobile, setImgLoadedMobile] = useState(false);

    const allImagesLoaded =
        imgLoadedDesktop && imgLoadedTablet && imgLoadedMobile;

    // Tamaño de viewport para que el confeti cubra toda la pantalla y se adapte
    const [viewport, setViewport] = useState({
        w: typeof window !== "undefined" ? window.innerWidth : 0,
        h: typeof window !== "undefined" ? window.innerHeight : 0,
    });

    useEffect(() => {
        const onResize = () => setViewport({ w: window.innerWidth, h: window.innerHeight });
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    // Precarga de imágenes antes de mostrar el modal
    useEffect(() => {
        const img1 = new window.Image();
        const img2 = new window.Image();
        const img3 = new window.Image();

        img1.src = iconopopup;
        img2.src = iconopopupTablet;
        img3.src = iconopopupCel;

        img1.onload = () => setImgLoadedDesktop(true);
        img2.onload = () => setImgLoadedTablet(true);
        img3.onload = () => setImgLoadedMobile(true);

        return () => {
            img1.onload = null;
            img2.onload = null;
            img3.onload = null;
        };
    }, []);

    // Solo cuando las imágenes ya están cargadas se aplica el efecto y muestra el modal
    useEffect(() => {
        if (!allImagesLoaded) return;
        document.body.style.overflow = "hidden";
        if (containerRef.current) {
            const options = {
                speed: 3,
                acceleration: 1.05,
                friction: 0.97,
                gravity: 1.5,
                particles: 50,
                trace: 3,
                explosion: 5,
                boundaries: {
                    top: 0,
                    bottom: containerRef.current.clientHeight,
                    left: 0,
                    right: containerRef.current.clientWidth,
                },
                sound: {
                    enable: false,
                },
            };
            const fireworks = new Fireworks(containerRef.current, options);
            fireworks.start();
            return () => {
                document.body.style.overflow = "unset";
            };
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [allImagesLoaded]);

    // Manejador para el clic fuera del contenido del modal
    const handleOutsideClick = (event) => {
        if (event.target === event.currentTarget) {
            onClose();
        }
    };

    // NO RENDERIZA NADA hasta que estén todas las imágenes cargadas
    if (!allImagesLoaded) return null;

    // Lluvia desde arriba en todo el ancho (para que no se amontone)
    const confettiSource = {
        x: 0,
        y: 0,
        w: viewport.w,
        h: 1, // franja muy fina arriba
    };

    // Ajustes por dispositivo: menos piezas y más lento en móvil
    const isMobile = viewport.w <= 768;
    const pieces = isMobile ? 100 : 150;       // menos en móvil para evitar "masa"
    const gravity = isMobile ? 0.06 : 0.07;    // más lento y fluido
    const friction = 0.99;                     // caída muy suave/estable

    return (
        <>
            {/* Confeti detrás del modal: zIndex bajo y sin bloquear clics */}
            {/*
            <Confetti
                width={viewport.w}
                height={viewport.h}
                numberOfPieces={pieces}
                recycle={true}         // sigue activo mientras el modal esté montado
                gravity={gravity}      // caída vertical lenta y fluida
                wind={0}               // sin viento lateral
                friction={friction}    // caída uniforme y suave
                confettiSource={confettiSource} // lluvia pareja desde arriba
                style={{ position: "fixed", inset: 0, pointerEvents: "none", zIndex: 100 }}
                run={true}
            />
            */}

            <section>
                <div
                    className="modalShadowNotificaciones centrado"
                    onClick={handleOutsideClick}
                >
                    <div className="caja-popup-notificaciones ">
                        <section className="d-flex justify-content-end mt-2">
                            <div className="me-1">
                                <button className="border-0 btn-filtro-cruz" onClick={onClose}>
                                    <FontAwesomeIcon className="fs-18 " icon={faXmark} />
                                </button>
                            </div>
                        </section>
                        <article className="d-none d-lg-block">
                            <div className="text-center">
                                <Image
                                    className="w-100"
                                    src={iconopopup}
                                    alt="icono icono"
                                    fluid
                                />
                                {/* <h6 className="text-center lato-bold fs-17"> Estimado Aliado</h6> */}
                                {/*<span className="text-center lato-bold fs-14">*/}
                                {/*Le informamos que, debido al feriado del próximo lunes 18/11 , los plazos y pagos se diferirán automáticamente al siguiente día hábil.                </span>*/}
                                {/* <span className="text-center lato-bold fs-14">
                Te informamos que estamos trabajando en una reducción de tasa del anticipo para ofrecerte mayores beneficios. Este cambio requiere una actualización en nuestros sistemas, por lo que las operaciones se acreditarán temporalmente en los plazos normales.
                <br />
                Gracias por tu comprensión y confianza.
              </span> */}
                            </div>
                        </article>
                        <article className="d-lg-none d-block">
                            <div className="text-center">
                                <div className="d-none d-md-block">
                                    <Image
                                        className="w-100"
                                        src={iconopopupTablet}
                                        alt="icono icono"
                                        fluid
                                    />
                                    {/* <h6 className="text-center lato-bold fs-17"> Estimado Aliado</h6> */}
                                    {/*<span className="text-center lato-bold fs-14">*/}
                                    {/*Le informamos que, debido al feriado del próximo lunes 18/11 , los plazos y pagos se diferirán automáticamente al siguiente día hábil. */}
                                    {/*</span>*/}
                                    {/* <span className="text-center lato-bold fs-14">
                  Te informamos que estamos trabajando en una reducción de tasa del anticipo para ofrecerte mayores beneficios. Este cambio requiere una actualización en nuestros sistemas, por lo que las operaciones se acreditarán temporalmente en los plazos normales.
                  <br />
                  Gracias por tu comprensión y confianza.
                </span> */}
                                </div>
                                <div className="d-md-none d-block">
                                    <Image
                                        className="w-100"
                                        src={iconopopupCel}
                                        alt="icono icono"
                                        fluid
                                    />
                                    {/* <h6 className="text-center lato-bold fs-14"> Estimado Aliado</h6> */}
                                    {/*  <span className="text-center lato-bold fs-12">*/}
                                    {/*  Le informamos que, debido al feriado del próximo lunes 18/11 , los plazos y pagos se diferirán automáticamente al siguiente día hábil.                </span>*/}
                                    {/* <span className="text-center lato-bold fs-12">
                  Te informamos que estamos trabajando en una reducción de tasa del anticipo para ofrecerte mayores beneficios. Este cambio requiere una actualización en nuestros sistemas, por lo que las operaciones se acreditarán temporalmente en los plazos normales.
                  <br />
                  Gracias por tu comprensión y confianza.
                </span>  */}
                                </div>
                            </div>
                        </article>
                        <article className="px-4">
                            <button
                                className="btn-popUp lato-bold fs-18 my-2  "
                                type="button"
                                onClick={onClose}
                            >
                                Cerrar
                            </button>
                        </article>
                    </div>
                </div>
            </section>
        </>
    );
};

export default PopUpNotificaciones;
